module.exports = __webpack_public_path__ + "1c6b7b0d9f39cc5e4b5a1ecbc6b6f6b1.jpg";